import React, { useState } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';

import Button from 'flow/components/ui-components/Button';
import SettingRow from 'flow/components/Setting/SettingRow';

import useAppContext from 'flow/hooks/useAppContext';

import { ExtensionKey } from 'flow/types/EntityKeys';

import { List } from 'immutable';
import { resetPassword } from 'flow/actions/user-credential-action';
import InfoBox, { InfoBoxType } from 'flow/components/ui-components/InfoBox';
import { getValidUserEmailOrNumber } from 'flow/utils/credential-utils';

interface Props {
    extensionKey: ExtensionKey;
}

const ResetPassword = ({ extensionKey }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const usernames = useAppSelector((state) =>
        state.extensions.getIn(
            ['extensions', extensionKey, 'usage', 'usernames'],
            List(),
        ),
    );

    const [requestSuccess, setRequestSuccess] = useState(false);
    const [resetInfo, setResetInfo] = useState('');

    const handleReset = async () => {
        const username = getValidUserEmailOrNumber(usernames);
        try {
            const couldRequest = await dispatch(resetPassword(username));
            const requestInfo = couldRequest
                ? 'settings.password.link_sent'
                : 'settings.password.no_valid_contact_information';
            setResetInfo(i18next.t(requestInfo));
            setRequestSuccess(!!couldRequest);
        } catch (e) {
            setRequestSuccess(false);
            setResetInfo(
                i18next.t('settings.password.no_valid_contact_information'),
            );
        }
    };

    return (
        <div className="grid gap-y-3">
            <SettingRow
                cta={
                    <Button
                        color="ghost"
                        className="px-5 text-sm whitespace-nowrap"
                        onClick={handleReset}
                    >
                        {i18next.t('settings.password.order_new')}
                    </Button>
                }
            >
                {i18next.t('settings.password.reset')}
            </SettingRow>

            {resetInfo ? (
                <InfoBox
                    type={
                        requestSuccess ? InfoBoxType.Info : InfoBoxType.Warning
                    }
                >
                    {resetInfo}
                </InfoBox>
            ) : null}
        </div>
    );
};

export default ResetPassword;
